import { useTranslation } from 'react-i18next'

import { DocumentValidityBadgeProps } from './DocumentValidityBadge.types'
import { Badge } from '@percent/lemonade'
import { DocumentValidity } from '@percent/admin-dashboard/api/types'

export function DocumentValidityBadge({ documentValidity }: Readonly<DocumentValidityBadgeProps>) {
  const { t } = useTranslation()

  switch (documentValidity) {
    case DocumentValidity.VALID:
      return (
        <Badge variant="positive" icon="check-badge">
          {t('typography.documentValidityValid')}
        </Badge>
      )
    case DocumentValidity.EXPIRED:
      return (
        <Badge variant="critical" icon="warning">
          {t('typography.documentValidityExpired')}
        </Badge>
      )
    case DocumentValidity.UNCLEAR:
      return (
        <Badge variant="warning" icon="warning">
          {t('typography.documentValidityUnclear')}
        </Badge>
      )
    default:
      return null
  }
}
